import React from "react";
import { Link } from "react-router-dom";

interface NotFoundProps {
  title?: string;
  message?: string;
  linkText?: string;
  linkDestination?: string;
}

const NotFound: React.FC<NotFoundProps> = ({
  title = "Item Not Found",
  message = "Sorry, we couldn't find the item you're looking for.",
  linkText = "Go back home",
  linkDestination = "/",
}) => {
  return (
    <div className="w-full max-w-md rounded-lg border border-oat bg-white p-8 text-center shadow-md md:p-12">
      <h1 className="mb-2 text-3xl font-bold text-soil">{title}</h1>

      <p className="mb-8 text-base text-gray-600">{message}</p>

      <Link
        to={linkDestination}
        className="inline-flex w-auto items-center justify-center rounded bg-cantelope px-6 py-3 font-bold text-soil transition-all hover:bg-soil hover:text-cantelope"
      >
        {linkText}
      </Link>
    </div>
  );
};

export default NotFound;
